import { showValidateOrder } from '@/event/order/showValidateOrder'

export const toggleShowValidateOrder = () => {
  showValidateOrder.value = !showValidateOrder.value
}
